import { render, staticRenderFns } from "./ads.vue?vue&type=template&id=47855838&scoped=true&"
import script from "./ads.vue?vue&type=script&lang=js&"
export * from "./ads.vue?vue&type=script&lang=js&"
import style0 from "./ads.vue?vue&type=style&index=0&id=47855838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47855838",
  null
  
)

export default component.exports